import { Const } from '~/constants/Const.constant';
import { battery, lastSeen } from '~/helpers/fields-description';
import { rfStatus } from '~/helpers/network-fields-description';
import { NAModule } from '~/models/modules/NAModule.model';

export class EBU extends NAModule {
    hasOperationReset = false;

    rf_status?: number;
    isWired = false;

    battery_levels = {
        full : Const.NABatteryLevelEBUModule.EBU_BATTERY_LEVEL_0,
        high : Const.NABatteryLevelEBUModule.EBU_BATTERY_LEVEL_1,
        medium : Const.NABatteryLevelEBUModule.EBU_BATTERY_LEVEL_2,
        low : Const.NABatteryLevelEBUModule.EBU_BATTERY_LEVEL_3,
    };
    loadData(data: any) {
        super.loadData(data);
    }

    get fieldBattery() {
        return battery(this.getBatteryIcon(this.battery_vp), this.battery_vp);
    }
    get fieldRfStatus() {
        return rfStatus(this.getRfIcon(this.rf_status), this.rf_status);
    }
    get fieldLastSeen() {
        return lastSeen(this.last_seen, this.outdatedLastSeen ? 'error--text' : '');
    }

}
